export function newsLink(articleUrl: string): { href: string; label: string } {
  let url: URL;
  try { url = new URL(articleUrl); } catch { return { href: articleUrl, label: "元記事" }; }
  if (url.hostname !== "www.data.jma.go.jp" || !url.pathname.startsWith("/developer/xml/")) return { href: articleUrl, label: "元記事" };
  const file = url.pathname.split("/").pop() ?? "";
  let page = "https://www.jma.go.jp/bosai/#area_type=class20s&area_code=3520700&lang=ja";
  if (/_VPWW\d+_/.test(file)) page = "https://www.jma.go.jp/bosai/warning/#area_type=class20s&area_code=3520700&lang=ja";
  if (/_VXSE\d+_/.test(file)) page = "https://www.jma.go.jp/bosai/map.html#contents=earthquake_map";
  if (/_VTSE\d+_/.test(file)) page = "https://www.jma.go.jp/bosai/map.html#contents=tsunami";
  // The destination shows current conditions, not a permanent copy of this bulletin.
  return { href: page, label: "気象庁で最新情報" };
}
